// React Imports
import { ReactElement } from "react";

// Third Party Libraries Imports
import ReactCountryFlag from "react-country-flag";

// Local Imports
import CollapseComponent from "../../../../components/collapse.component";

interface CommunicationAddressProps {
  [key: string]: any;
}

const CommunicationAddress: React.FC<CommunicationAddressProps> = ({
  accountKycDetails,
}: CommunicationAddressProps): ReactElement => {
  return (
    <section className="flex flex-col w-full h-full">
      <div className="flex flex-col p-[10px]">
        <CollapseComponent
          header={
            <div className="flex gap-3 items-center">
              <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
              <h3 className=" text-xl font-semibold">Communication details</h3>
            </div>
          }
        >
          <div className="flex gap-5 flex-wrap mb-5">
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Mobile number
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.mobileNumber || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Work number
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.workNumber || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Home number
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.homeNumber || "-"}
              </span>
            </div>
          </div>
        </CollapseComponent>
        <CollapseComponent
          header={
            <div className="flex gap-3 items-center">
              <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
              <h3 className=" text-xl font-semibold">
                Residential address details
              </h3>
            </div>
          }
        >
          <div className="flex gap-5 flex-wrap mb-5">
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Country
              </p>
              <div className="flex items-center gap-2">
                <ReactCountryFlag
                  style={{
                    fontSize: "24px",
                  }}
                  countryCode={
                    accountKycDetails?.accountInfo[0]?.residentialCountry
                      ?.countryCode
                  }
                  svg
                />
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.residentialCountry
                    ?.nameEn || "-"}
                </span>
              </div>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                city
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.residentialCity || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Building
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.residentialBuilding || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Street
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.residentialStreet || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Avenue
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.residentialAvenue || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Block
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.residentialBlock || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                P.O.Box
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.residentialPoBox || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Postal code
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.residentialZipCode || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Additional address details
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.residentialAddressDetails ||
                  "-"}
              </span>
            </div>
          </div>
        </CollapseComponent>
        <CollapseComponent
          header={
            <div className="flex gap-3 items-center">
              <span className="w-[5px] bg-blue-500 h-[25px] rounded-[10px]"></span>
              <h3 className=" text-xl font-semibold">Work address details</h3>
            </div>
          }
        >
          <div className="flex gap-5 flex-wrap mb-5">
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Country
              </p>
              <div className="flex items-center gap-2">
                <ReactCountryFlag
                  style={{
                    fontSize: "24px",
                  }}
                  countryCode={
                    accountKycDetails?.accountInfo[0]?.workCountry?.countryCode
                  }
                  svg
                />
                <span className=" text-base font-semibold text-lightGray-200">
                  {accountKycDetails?.accountInfo[0]?.workCountry?.nameEn ||
                    "-"}
                </span>
              </div>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                City
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.workCity || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Building
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.workBuilding || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Street
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.workStreet || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Avenue
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.workAvenue || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Block
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.workBlock || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                P.O.Box
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.workPoBox || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Postal code
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.workPostalCode || "-"}
              </span>
            </div>
            <div className="w-[100%] md:w-[48%] lg:w-[32%] flex flex-col mb-3">
              <p className=" text-black-300 text-xs font-normal mb-[10px]">
                Additional address details
              </p>
              <span className=" text-base font-semibold text-lightGray-200">
                {accountKycDetails?.accountInfo[0]?.workAddressDetails || "-"}
              </span>
            </div>
          </div>
        </CollapseComponent>
      </div>
    </section>
  );
};

export default CommunicationAddress;
